import React from "react";

const TermsPolicy = () => {
  return (
    <div className="px-6 py-10 max-w-4xl mx-auto text-gray-800 leading-relaxed">
      <h1 className="text-3xl font-bold mb-14 text-center text-primary">
        Academia Insight – Policies & Terms
      </h1>

      {/* Terms and Conditions */}
      <section className="mb-10">
        <h2 className="text-2xl font-semibold mb-4 text-gray-900">
          Terms and Conditions
        </h2>
        <p className="mb-4">
          By using the services of Academia Insight Institute of Research
          Studies, you agree to abide by the following terms and conditions.
          These terms govern your use of our website, access to learning
          materials, and participation in our academic programs.
        </p>
        <p className="mb-4">
          Our institute provides academic workshops, faculty development
          programs (FDPs), training in research tools, and publication-related
          services. All programs are offered for educational purposes only. By
          registering, you agree to use the content provided—such as slides,
          videos, and software guidance—for personal learning and not for
          redistribution, resale, or public display.
        </p>
        <p className="mb-4">
          All intellectual property including course materials, recordings, and
          design content belongs solely to Academia Insight Institute of
          Research Studies. Unauthorized copying, duplication, or sharing of
          this content is strictly prohibited.
        </p>
        <p className="mb-4">
          We reserve the right to modify the schedule, structure, or content of
          any program. In cases of unexpected changes, registered participants
          will be duly informed. We also reserve the right to deny access to
          individuals found misusing our services or violating our policies.
        </p>
        <p>
          Our liability is limited to the scope of service provided. We do not
          guarantee publication, selection in academic journals, or professional
          advancement based on participation alone.
        </p>
      </section>

      {/* Privacy Policy */}
      <section className="mb-10">
        <h2 className="text-2xl font-semibold mb-4 text-gray-900">
          Privacy Policy
        </h2>
        <p className="mb-4">
          At Academia Insight Institute of Research Studies, we value your trust
          and are committed to protecting your privacy. This Privacy Policy
          outlines how we collect, use, share, and safeguard your personal data
          when you interact with our website or participate in our academic
          offerings.
        </p>
        <p className="mb-4">
          When you register for a workshop, course, or event, we collect
          information such as your name, email address, phone number,
          professional affiliation, and academic interests. We may also gather
          limited technical data like your IP address and browser type for
          analytics and system improvement. Payment information is collected
          through secure third-party gateways; we do not store your card or
          banking details directly.
        </p>
        <p className="mb-4">
          The information you provide is used to confirm registrations, send
          workshop updates, generate participation certificates, and offer
          personalized communication. We may also use this data to improve the
          content and delivery of our services.
        </p>
        <p className="mb-4">
          We do not sell or rent your personal data to any third party. However,
          we may share your information with trusted service providers (such as
          email tools, cloud storage, or certificate automation platforms)
          strictly for operational purposes. All data is handled with
          confidentiality and protected using appropriate administrative and
          technical safeguards.
        </p>
        <p>
          You have the right to access, correct, or delete your personal data.
          For any data-related queries or requests, please contact us
          Academicainsightirs@gmail.com.
        </p>
      </section>

      {/* Refund and Cancellation Policy */}
      <section className="mb-10">
        <h2 className="text-2xl font-semibold mb-4 text-gray-900">
          Refund and Cancellation Policy
        </h2>
        <p className="mb-4">
          At Academia Insight Institute of Research Studies, we strive to
          deliver quality academic experiences and ensure a smooth registration
          process. However, we understand that sometimes participants may need
          to cancel their registration.
        </p>
        <p className="mb-4">
          If a participant chooses to cancel their registration at least 48
          hours prior to the event, a full refund will be processed without any
          penalty. Cancellations made within 48 hours of the event or
          non-attendance will not be eligible for a refund.
        </p>
        <p className="mb-4">
          Refunds, where applicable, will be processed using the same method
          through which the original payment was made. Participants can expect
          the amount to be credited within 7 to 10 business days, depending on
          the payment gateway and banking process.
        </p>
        <p>
          In the rare event that a session is cancelled or rescheduled by us,
          participants will be informed in advance and offered either a full
          refund or the option to attend on the new date.
        </p>
      </section>

      {/* Disclaimer */}
      <section>
        <h2 className="text-2xl font-semibold mb-4 text-gray-900">
          Disclaimer
        </h2>
        <p className="mb-4">
          The information, tools, and resources provided by Academia Insight
          Institute of Research Studies are for general academic and research
          purposes only. While we make every effort to ensure the accuracy and
          quality of content, we do not guarantee academic outcomes such as
          publication acceptance, funding, or institutional approvals.
        </p>
        <p>
          Participation in our workshops, FDPs, or certificate programs should
          not be construed as professional accreditation, job placement
          assistance, or legal/medical advice. Users are advised to
          independently verify and cross-check any strategy, tool, or
          methodology shared during training sessions before applying it in
          their academic or professional context.
        </p>
        <p className="mt-4">
          Academia Insight disclaims liability for any loss, damage, or academic
          consequences arising from the use of its content, services, or
          recommendations.
        </p>
      </section>
    </div>
  );
};

export default TermsPolicy;
